import api from '@/api'
import utils from '@/utils/utils.js'


export default {
    namespaced: true, //在module中企业命名空间
    state: {
        token: utils.getToken(),
        username: utils.getSession('USER_NAME'), // 账号名称
		permission:utils.getSession('PERMISSION'),
		roleId:utils.getSession('ROLEID'), // 角色id
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
            utils.setSession("TOKEN", token);
        },
        SET_USER_NAME: (state, username) => {
            state.username = username
            utils.setSession("USER_NAME", username);
        },
		SET_PERMISSION:(state, permission) => {
            state.permission = permission
            utils.setSession("PERMISSION", permission);
        },
		SET_ROLEID:(state, roleId) => {
            state.roleId = roleId
            utils.setSession("ROLEID", roleId);
        },
    },
    actions: {
        
    }
}